import { RadioGroupProps } from "./RadioGroupProps";
import { RadioGroupContext } from "./RadioGroupContext";
import { clsx } from "clsx";
import classes from "./Radio.module.scss";
import { useFormControl } from "@/hooks/useFormControl";

export function RadioGroup(props: RadioGroupProps) {
  const {
    children,
    direction = "row",
    className,
    name,
    value,
    onChange,
    defaultValue,
    layout,
  } = props;
  const formControl = useFormControl();
  const legendId = formControl?.legendId;

  // `aria-invalid` is supported on a radiogroup but not on the fieldset's
  // plain group role, so the error state lives here. A radiogroup requires a
  // name, so without a legend the group stays a plain div.
  const radioGroupProps = legendId
    ? {
        role: "radiogroup",
        "aria-labelledby": legendId,
        ...(formControl?.hasError && { "aria-invalid": true }),
      }
    : {};

  return (
    <div
      {...radioGroupProps}
      className={clsx(
        classes.radioGroup,
        {
          [classes.columnDireccion]: direction === "column",
          [classes.gridLayout]: layout === "grid",
          [classes.autoFitLayout]: layout === "auto-fit",
          [classes.autoFitLayoutLarge]: layout === "auto-fit-large",
        },
        className,
      )}
    >
      <RadioGroupContext.Provider
        value={{ value, defaultValue, onChange, name }}
      >
        {children}
      </RadioGroupContext.Provider>
    </div>
  );
}
